import { render, staticRenderFns } from "./ResultsImportRows.vue?vue&type=template&id=5c706064&scoped=true"
import script from "./ResultsImportRows.vue?vue&type=script&lang=js"
export * from "./ResultsImportRows.vue?vue&type=script&lang=js"
import style0 from "./ResultsImportRows.vue?vue&type=style&index=0&id=5c706064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c706064",
  null
  
)

export default component.exports